
import React, { useState } from "react";
import TableRow from '@mui/material/TableRow';
import { Draggable } from "react-beautiful-dnd";
import TableCell from '@mui/material/TableCell';
import ReorderIcon from '@mui/icons-material/Reorder';


export const Drag = ({ id, index, ...props }) => {
    const getItemStyle = (isDragging, draggableStyle) => ({
        background: isDragging ? "#f5f1f1" : "white",
        ...draggableStyle
    });

    return (
        <Draggable draggableId={id} index={index}>
            {(provided, snapshot) => {
                return (

                    <TableRow 
                        ref={provided.innerRef} 
                        sx={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                    )}

                        {...provided.draggableProps}  {...props}>
                             <TableCell align="left" {...provided.dragHandleProps}>
                                <ReorderIcon/>
                                 </TableCell>
                        {props.children}
                    </TableRow>
                );
            }}
        </Draggable>
    );
};
